import type { MatchResultDetailNode, UseMatchEditorResult } from "./use-match-editor";
import type { ResultTeamLike } from "./ResultPanel";
import type { ResultPerson } from "./match-result-derive";
import type { AutoAddition } from "./auto-match/auto-match-runs";

const NO_ADDITIONS: readonly AutoAddition[] = [];

export function normaliseResultTeams(
  teams:
    | NonNullable<UseMatchEditorResult["solverResult"]>["teams"]
    | MatchResultDetailNode["teams"]
    | null
    | undefined,
): ResultTeamLike[] {
  return (teams ?? []).map((t) => ({
    teamId: t.teamId,
    result: t.result ?? null,
    // Nur gespeicherte Ergebnisse tragen angehängte Zeilen; der Entwurf des Solvers fragt sie nicht ab.
    autoAdded: ("autoAdded" in t && t.autoAdded ? t.autoAdded : NO_ADDITIONS) as readonly AutoAddition[],
    persons: (t.persons ?? [])
      .filter((p): p is NonNullable<typeof p> => Boolean(p))
      .map((p) => {
        const given = Array.isArray(p.name?.given) ? p.name?.given : [p.name?.given];
        const fullName =
          [...(given ?? []), p.name?.family].filter(Boolean).join(" ") || p.formattedName || "?";
        const av = (p as { avatar?: { content?: string | null; mimeType?: string | null } | null }).avatar;
        return {
          id: p.id,
          name: fullName,
          profession: p.profession ?? null,
          avatarContent: av?.content ?? null,
          avatarMime: av?.mimeType ?? null,
        } satisfies ResultPerson;
      }),
  }));
}
